module.exports = __webpack_public_path__ + "static/media/guardian-team-right.4e74baa5.webp";